export default __webpack_public_path__ + "static/media/8-10-v1.b21b5562.png";